import Swal from 'sweetalert2'
import { api } from '../../domainConfig';
import axiosInstance from '../axiosInstance';

/* eslint no-shadow: ["error", { "allow": ["state"] }] */

const domain = api.userManagementDomain;
const domain1 = api.clientMasterDataDomain;
const domain3 = api.storeDataDomain


const state = {
  status: false,
  users: [],
  inactiveusers: [],
  fileteredActiveUsers: [],
  filteredInactiveUsers: [],
  userRole: [],
  currentPage: 1,
  totalItems: 0,
  totalItems_2: 0,
  totalItemsInactive: 0,
  totalPagesUsers: 0,
  notifications: [],
  notificationCount: 0,
  notificationCountFromBack: 0,
  totalItemsStore: 0,
  totalPagesStore: 0,
  totalItemsForUsers: 0,
  totalPagesForUsers: 0,
  payment: [],
  employeePaymentPagination: [],
  userPDF: [],
  feedback: [],
  employeeFeedbackPagination: [],
  feedbackForDashboard: [],
  monthlyOverviewPaymentPagination: [],
  fullUserById: {},
  employeeBirthdays: [],
  usersActiveInactive: [],
  dashboardSalary: [],
  employeeTotalNumber: [],
  employeesOnVacation: [],
  storeNames: [],
  allStoresByPagination: [],
  storesDropdown: [],
  allStoresDropdown: [],
  userPaginationWorkplace: [],
  storesByNameLike: [],
  resetStore: [],
  regularEmployeesById: [],
  salesEmployees: [],
};

const getters = {
  getUsers: (state) => {
    return state.users;
  },
  getSalesEmployees: (state) => {
    return state.salesEmployees
  },
  getMonthlyOverviewPaymentPagination: (state) => {
    return state.monthlyOverviewPaymentPagination
  },
  getTotalPagesUsers: (state) => {
    return state.totalPagesUsers
  },
  getStoresDropdown: (state) => {
    return state.storesDropdown
  },
  getAllStoresDropdown: (state) => {
    return state.allStoresDropdown
  },
  getRegularEmployeesById: (state) => {
    return state.regularEmployeesById
  },
  getPayment: (state) => {
    return state.payment
  },
  getUserRole: (state) => {
    return state.userRole
  },
  getEmployeeBirthdays: (state) => {
    return state.employeeBirthdays
  },
  getFullUsersById: (state) => {
    return state.fullUserById;
  },
  getInactiveUsers: (state) => {
    return state.inactiveusers;
  },

  getCurrentPageForUsers: (state) => {
    return state.currentPage;
  },

  getFilteredActiveUsers: (state) => {
    return state.fileteredActiveUsers;
  },
  getFilteredInactiveUsers: (state) => {
    return state.filteredInactiveUsers;
  },

  getTotalItemsForUsers: (state) => {
    return state.totalItems;
  },
  getTotalItemsForUsers_2: (state) => {
    return state.totalItems_2;
  },
  getTotalItemsForInActiveUsers: (state) => {
    return state.totalItemsInactive;
  },
  getNotifications: (state) => {
    // console.log('wer', state.notifications)
    return state.notifications
  },
  getNotificationCount(state) {
    return state.notificationCount;
  },
  getNotificationCountFromBack(state) {
    return state.notificationCountFromBack
  },
  getEmployeePaymentPagination: (state) => {
    return state.employeePaymentPagination
  },
  getUserPDF: (state) => {
    return state.userPDF
  },
  getFeedback: (state) => {
    return state.feedback
  },
  getEmployeeFeedbackPagination: (state) => {
    return state.employeeFeedbackPagination
  },
  getFeedbackForDashboard: (state) => {
    return state.feedbackForDashboard
  },
  getUsersActiveInactive: (state) => {
    return state.usersActiveInactive
  },
  getDashboardSalary: (state) => {
    return state.dashboardSalary
  },
  getEmployeeTotalNumber: (state) => {
    return state.employeeTotalNumber
  },
  getEmployeesOnVacation: (state) => {
    return state.employeesOnVacation
  },
  getStoreNameByLeadership: (state) => {
    return state.storeNames
  },
  getAllStores: (state) => {
    return state.allStoresByPagination
  },
  getAllStoresTotalItems: (state) => {
    return state.totalItemsStore
  },
  getAllStoresTotalPages: (state) => {
    return state.totalPagesStore
  },
  getUsersPaginationWorkplace: (state) => {
    return state.userPaginationWorkplace
  },
  getUsersPaginationWorkplaceTotalItems: (state) => {
    return state.totalItemsForUsers
  },
  getUsersPaginationWorkplaceTotalPages: (state) => {
    return state.totalPagesForUsers
  },
  getStoresByNameLike: (state) => {
    return state.storesByNameLike
  },
  getResetStore: (state) => {
    return state.resetLocation;
  },
};

const mutations = {
  SET_STATUS(state, payload) {
    state.status = payload;
  },
  SET_USERS_SALES(state, payload) {
    state.salesEmployees = payload;
  },
  SET_MONTHLY_OVERVIEW_PAYMENT_PAGINATION(state, data) {
    state.monthlyOverviewPaymentPagination = data
  },
  SET_STORES_DROPDOWN(state, latest) {
    state.storesDropdown = latest
  },
  SET_ALL_STORES_DROPDOWN(state, latest) {
    state.allStoresDropdown = latest
  },
  SET_EMPLOYES_REGULAR_BYID(state, latest) {
    state.regularEmployeesById = latest
  },
  SET_PAYMENT(state, data) {
    state.payment = data
  },
  SET_EMPLOYEE_PAYMENT_PAGINATION(state, data) {
    state.employeePaymentPagination = data
  },
  SET_CURRENTPAGE(state, payload) {
    state.currentPage = payload;
  },
  SET_TOTAL_PAGES(state, latest) {
    state.totalPagesUsers = latest
  },
  SET_CURRENTPAGE_2(state, payload) {
    state.currentPage = payload;
  },
  SET_USERS(state, latest) {
    state.users = latest;
  },
  SET_USER_ROLE(state, payload) {
    state.userRole = payload
  },
  SET_INACTIVEUSERS(state, latest) {
    state.inactiveusers = latest;
  },
  SET_EMPLOYEE_BIRTHDAYS(state, latest) {
    state.employeeBirthdays = latest
  },
  SET_FULL_USERS_BY_ID(state, latest) {
    state.fullUserById = latest
  },
  SET_FILTERED_ACTIVE_USERS(state, latest) {
    state.fileteredActiveUsers = latest;
  },
  SET_FILTERED_INACTIVEUSERS(state, latest) {
    state.filteredInactiveUsers = latest;
  },
  SET_TOTALITEMS_USERS(state, latest) {
    state.totalItems = latest;
  },
  SET_TOTALITEMS_USERS_2(state, latest) {
    state.totalItems_2 = latest;
  },
  SET_TOTALITEMS_INACTIVEUSERS(state, latest) {
    state.totalItemsInactive = latest;
  },
  SET_NOTIFICATIONS(state, latest) {
    state.notifications = latest
  },
  INCREMENT_NOTIFICATION_COUNT(state, latest) {
    state.notificationCount = latest;
  },
  RESET_NOTIFICATION_COUNT(state) {
    state.notificationCount = 0;
  },
  SET_NOTIFICATION_COUNT_FROM_BACKEND(state, latest) {
    state.notificationCountFromBack = latest
  },
  RESET_NOTIFICATION_COUNT_FROM_BACKEND(state, latest) {
    state.notificationCountFromBack = latest
  },
  SET_USER_PDF(state, latest) {
    state.userPDF = latest
  },
  SET_FEEDBACK(state, data) {
    state.feedback = data
  },
  SET_EMPLOYEE_FEEDBACK_PAGINATION(state, data) {
    state.employeeFeedbackPagination = data
  },
  SET_FEEDBACK_FOR_DASHBOARD(state, data) {
    const res = data.sort((a, b) => {
      return b.rangingValue - a.rangingValue
    })
    state.feedbackForDashboard = res
  },
  SET_USERS_ACTIVE_INACTIVE(state, latest) {
    state.usersActiveInactive = latest
  },
  SET_DASHBOARD_SALARY(state, latest) {
    state.dashboardSalary = latest
  },
  SET_EMPLOYEE_TOTAL_NUMBER(state, latest) {
    state.employeeTotalNumber = latest
  },
  SET_EMPLOYEE_ON_VACATION(state, latest) {
    state.employeesOnVacation = latest
  },
  SET_STORE_NAMES(state, latest) {
    state.storeNames = latest
  },
  SET_STORES_BY_PAGINATION(state, latest) {
    state.allStoresByPagination = latest
  },
  SET_STORES_BY_PAGINATION_TOTALITEMS(state, latest) {
    state.totalItemsStore = latest
  },
  SET_STORES_BY_PAGINATION_TOTALPAGES(state, latest) {
    state.totalPagesStore = latest
  },
  SET_USERS_WORKPLACE(state, latest) {
    state.userPaginationWorkplace = latest
  },
  SET_USERS_WORKPLACE_TOTALITEMS(state, latest) {
    state.totalItemsForUsers = latest
  },
  SET_USERS_WORKPLACE_TOTALPAGES(state, latest) {
    state.totalPagesForUsers = latest
  },
  SET_STORES_BY_NAME_LIKE(state, latest) {
    state.storesByNameLike = latest
  },
  SET_RESET_STORE(state, latest) {
    state.resetLocation = latest
  },
};
const actions = {
  async getUsersPagination({ commit }, { pageNumber, pageSize, fullName }) {
    const requestId = 'getUsersPagination'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/getUsersPagination`, {
        params: {
          pageNumber,
          pageSize,
          fullName,
        },
      });
      commit('SET_USERS', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_USERS', response.data.totalItems);
      commit('SET_TOTAL_PAGES', response.data.totalPages);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async storeByNameLike({ commit }, { storeName }) {
    const requestId = 'storeByNameLike'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/storeByNameLike?storeName=${storeName}`, {
      });
      commit('SET_STORES_BY_NAME_LIKE', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetStores({ commit }) {
    commit('SET_RESET_STORE', [])
  },
  async usersWorkPlacePagination({ commit }, {
    pageNumber, pageSize, status, userId, storeId,
  }) {
    const requestId = 'usersWorkPlacePagination'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/users_pagination_wokplace`, {
        params: {
          pageNumber,
          pageSize,
          status,
          userId,
          storeId,
        },
      });
      commit('SET_USERS_WORKPLACE', response.data.items);
      commit('SET_USERS_WORKPLACE_TOTALITEMS', response.data.totalItems);
      commit('SET_USERS_WORKPLACE_TOTALPAGES', response.data.totalPages);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async getStoreNames({ commit }) {
    const requestId = 'getStoreNames'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/storeNames_by_leadership`);
      commit('SET_STORE_NAMES', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async storesByPagination({ commit }, { pageNumber, pageSize, storeName }) {
    const requestId = 'storesByPagination'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/extendedStoresByPagination`, {
        params: {
          pageNumber,
          pageSize,
          storeName,
        },
      });
      commit('SET_STORES_BY_PAGINATION', response.data.items);
      commit('SET_STORES_BY_PAGINATION_TOTALITEMS', response.data.totalItems);
      commit('SET_STORES_BY_PAGINATION_TOTALPAGES', response.data.totalPages);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addStore({ commit }, { object, successCallback }) {
    const requestId = 'addStore'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain3}/addStore`, object, {
        headers: { 'Content-Type': 'application/json' },
      });
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Store created successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback();
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid store data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: 'An error occurred while adding a store.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
    }
    // commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async assignEmployeeToStore({ commit }, { object, successCallback }) {
    const requestId = 'assignEmployeeToStore'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain3}/assignEmployeeToStore`, object, {
        headers: { 'Content-Type': 'application/json' },
      });
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Employee assigned to store successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback();
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid employee data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: 'An error occurred while assigning employee to store.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
    }
    // commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async editStoreOfEmployee({ commit }, { object, successCallback }) {
    const requestId = 'editStoreOfEmployee'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain3}/updateStoreOfEmployee`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Store of employee is edited successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      Swal.fire({
        icon: 'error',
        title: 'An error occurred while editing the store of employee.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async activeInactiveUsers({ commit }, {
    pageNumber, pageSize, status, userId,
  }) {
    const requestId = 'activeInactiveUsers'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/active_inactive_users_pagination`, {
        params: {
          pageNumber,
          pageSize,
          status,
          userId,
        },
      });
      commit('SET_USERS_ACTIVE_INACTIVE', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_USERS', response.data.totalItems);
      commit('SET_TOTAL_PAGES', response.data.totalPages);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async dashboardSalarySum({ commit }, { year, month }) {
    const requestId = 'dashboardSalarySum'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/dashboard_sum_salary`, {
        params: {
          year,
          month,
        },
      });
      commit('SET_DASHBOARD_SALARY', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async employeeTotalNumberDashboard({ commit }, { status }) {
    const requestId = 'employeeTotalNumberDashboard'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/employees_count`, {
        params: {
          status,
        },
      });
      commit('SET_EMPLOYEE_TOTAL_NUMBER', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async employeesOnVacationByDate({ commit }, { date }) {
    const requestId = 'employeesOnVacationByDate'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/employees_on_vacation_by_date`, {
        params: {
          date,
        },
      });
      commit('SET_EMPLOYEE_ON_VACATION', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async employeeBirthdays({ commit }, { startDate, endDate }) {
    const requestId = 'employeeBirthdays'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/upcomingUsersBirthdayDay`, {
        params: {
          startDate,
          endDate,
        },
      });
      commit('SET_EMPLOYEE_BIRTHDAYS', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadEmployeeFeedbackPagination({ commit }, {
    firstName, lastName, pageNumber, pageSize,
  }) {
    const requestId = 'loadEmployeeFeedbackPagination'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/employeeFeedbackPagination`, {
        params: {
          firstName, lastName, pageNumber, pageSize,
        },
      });
      commit('SET_EMPLOYEE_FEEDBACK_PAGINATION', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_USERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadFeedback({ commit }, {
    userId, year,
  }) {
    const requestId = 'loadFeedback'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/feedback`, {
        params: {
          userId, year,
        },
      });
      commit('SET_FEEDBACK', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadFeedbackForDashboard({ commit }) {
    const requestId = 'loadFeedbackForDashboard'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/feedbackForDashboard`);
      commit('SET_FEEDBACK_FOR_DASHBOARD', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async add_feedback({ commit }, { object, successCallback }) {
    const requestId = 'add_feedback'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/add_feedback`, object, {
        headers: { 'Content-Type': 'application/json' },
      });
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'User`s feedback added successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback();
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid user data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: 'An error occurred while adding the user.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addRoleToLead({ commit }, { successCallback, clientId, ownerUserId }) {
    const requestId = 'addRoleToLead'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain1}/set_owner_userId?clientId=${clientId}&ownerUserId=${ownerUserId}`);
      commit('SET_STATUS', true);
      successCallback();
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addImageUser({ commit }, { object, successCallback }) {
    const requestId = 'addImageUser'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/add_user_profile`, object);
      commit('SET_STATUS', true);
      successCallback();
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async sendEmailToUser({ commit }, { object, successCallback }) {
    const requestId = 'sendEmailToUser'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/sendEmailToUser`, object, {
        headers: { 'Content-Type': 'application/json' },
      });
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Email sent successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback();
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid user data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: 'An error occurred while sending the email to the user.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
    }
    // commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async sendEmailToClientForDress({ commit }, { object, successCallback }) {
    const requestId = 'sendEmailToClientForDress'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain1}/sendEmailToClient`, object, {
        headers: { 'Content-Type': 'application/json' },
      });
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Email sent successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback();
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid user data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: 'An error occurred while sending the email to the user.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
    }
    // commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async edit_feedback({ commit }, { feedbackId, object, successCallback }) {
    const requestId = 'edit_feedback'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/edit_feedback?feedbackId=${feedbackId}`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'User feedback is edited successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      Swal.fire({
        icon: 'error',
        title: 'An error occurred while deactivating the user.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async editStores({ commit }, { storeId, object, successCallback }) {
    const requestId = 'editStores'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain3}/editStoreById/storeId?storeId=${storeId}`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Store edited successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      Swal.fire({
        icon: 'error',
        title: 'An error occurred while editing the store.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async loadUserPDF({ commit }, {
    pageNumber, pageSize, status, userId, storeId,
  }) {
    const requestId = 'loadUserPDF'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/users_pagination_wokplace`, {
        params: {
          pageNumber,
          pageSize,
          status,
          userId,
          storeId,
        },
      });
      commit('SET_USER_PDF', response.data);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_USERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadEmployeePaymentPagination({ commit }, {
    firstName, lastName, employeeType, pageNumber, pageSize,
  }) {
    const requestId = 'loadEmployeePaymentPagination'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/employeePaymentPagination`, {
        params: {
          firstName, lastName, employeeType, pageNumber, pageSize,
        },
      });
      commit('SET_EMPLOYEE_PAYMENT_PAGINATION', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_USERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadMonthlyOverviewPaymentPagination({ commit }, {
    year, month, employeeType, filterPaidEmployees, pageNumber, pageSize,
  }) {
    const requestId = 'loadMonthlyOverviewPaymentPagination'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/monthlyOverviewPaymentPagination`, {
        params: {
          year, month, employeeType, filterPaidEmployees, pageNumber, pageSize,
        },
      });
      commit('SET_MONTHLY_OVERVIEW_PAYMENT_PAGINATION', response.data.items);
      commit('SET_CURRENTPAGE_2', response.data.currentPage);
      commit('SET_TOTALITEMS_USERS_2', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadPayments({ commit }, {
    userId, year,
  }) {
    const requestId = 'loadPayments'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/payment`, {
        params: {
          userId, year,
        },
      });
      commit('SET_PAYMENT', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadStoresByDropdown({ commit }, {
    amountOfRecords,
  }) {
    const requestId = 'loadStoresByDropdown'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/stores_for_Dropdown`, {
        params: {
          amountOfRecords,
        },
      });
      commit('SET_STORES_DROPDOWN', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadAllStoresByDropdown({ commit }, {
    amountOfRecords,
  }) {
    const requestId = 'loadAllStoresByDropdown'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/all_stores_for_Dropdown`, {
        params: {
          amountOfRecords,
        },
      });
      commit('SET_ALL_STORES_DROPDOWN', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadRegularEmployeesId({ commit }, { storeId }) {
    const requestId = 'loadRegularEmployeesId'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/regular_employees_by_storeId`, {
        params: { storeId },
      });
      commit('SET_EMPLOYES_REGULAR_BYID', response.data);
      return response.data;
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      return [];
    } finally {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
  },
  async resetLoadRegularEmployeesId({ commit }) {
    commit('SET_EMPLOYES_REGULAR_BYID', []);
  },
  async loadSalesEmployees({ commit }, { object, successCallback }) {
    const requestId = 'loadSalesEmployees'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.post(`${domain}/users_by_storeId_and_roles`, object, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      commit('SET_USERS_SALES', response.data);
      if (successCallback) successCallback();
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      console.error('Error fetching users by multiple roles:', error);
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetLoadSalesEmployees({ commit }) {
    commit('SET_USERS_SALES', []);
  },
  async getInactiveUsersPagination({ commit }, { pageNumber, pageSize, fullName }) {
    const requestId = 'getInactiveUsersPagination'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/inactiveUsersPagination`, {
        params: {
          pageNumber,
          pageSize,
          fullName,
        },
      });
      commit('SET_INACTIVEUSERS', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_INACTIVEUSERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async fullUserById({ commit }, userId, successCallback) {
    const requestId = 'fullUserById'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/fullUserById`,
        {
          params: {
            userId,
          },
        })
      commit('SET_FULL_USERS_BY_ID', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async getUsersRole({ commit }) {
    const requestId = 'getUsersRole'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/getUserRole`)
      commit('SET_USER_ROLE', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addUser({ commit }, { object, successCallback }) {
    const requestId = 'addUser'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/addUser`, object, {
        headers: { 'Content-Type': 'application/json' },
      });
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'User created successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Please provide a new user',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async deactivateUserById({ commit }, { id, successCallback }) {
    const requestId = 'deactivateUserById'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/deactivateUserById?userId=${id}`);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async activateUserById({ commit }, { id, successCallback }) {
    const requestId = 'activateUserById'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/activateUserById?userId=${id}`);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async editUserById({ commit }, { object, successCallback }) {
    const requestId = 'editUserById'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/editUserById?userId=${object.userId}`, object);
      commit('SET_STATUS', true);
      successCallback();
      Swal.fire({
        icon: 'success',
        title: 'User edited succesfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid user data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async filterActiveUsersByName({ commit }, name) {
    const requestId = 'filterActiveUsersByName'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/activeUsersByFullNameLike?fullName=${name}`);
      commit('SET_FILTERED_ACTIVE_USERS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  resetFilteredActiveUsers({ commit }) {
    commit('SET_FILTERED_ACTIVE_USERS', []);
  },
  async filterInactiveUsersByName({ commit }, name) {
    const requestId = 'filterInactiveUsersByName'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/inactiveUsersByFullNameLike?fullName=${name}`);
      commit('SET_FILTERED_INACTIVEUSERS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  resetFilteredInactiveUsers({ commit }) {
    commit('SET_FILTERED_INACTIVEUSERS', []);
  },
  async loadNotifications({ commit }, { pageNumber, pageSize }) {
    const requestId = 'loadNotifications'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/notifications`, {
        params: {
          pageNumber,
          pageSize,

        },
      });
      commit('SET_NOTIFICATIONS', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_USERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async add_payment({ commit }, { object, successCallback }) {
    const requestId = 'add_payment'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/add_payment`, object);
      commit('SET_STATUS', true);
      successCallback();
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false })
  },
  async edit_payment({ commit }, { paymentId, object, successCallback }) {
    const requestId = 'edit_payment'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/edit_payment?paymentId=${paymentId}`, object);
      commit('SET_STATUS', true);
      successCallback();
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      // Handle error response
      // Show error message using SweetAlert if needed
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  incrementNotificationCount({ commit }, value) {
    commit('RESET_NOTIFICATION_COUNT_FROM_BACKEND', value);
  },
  resetNotificationCount({ commit }) {
    commit('RESET_NOTIFICATION_COUNT');
  },
  async mark_all_read({ commit }) {
    const requestId = 'mark_all_read'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/mark_all_read`);
      commit('RESET_NOTIFICATION_COUNT_FROM_BACKEND', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async mark_read({ commit }, notificationId) {
    const requestId = 'mark_read'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/mark_read?notificationId=${notificationId}`);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async notifications_number({ commit }) {
    const response = await axiosInstance.get(`${domain}/notifications_number`);
    commit('SET_NOTIFICATION_COUNT_FROM_BACKEND', response.data);
  },
  resetNotificationCountFromBack({ commit }) {
    commit('RESET_NOTIFICATION_COUNT_FROM_BACKEND');
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
